import React from 'react';
import { useSelector } from 'react-redux';
import { CURRENCY_SIGN, FILTER_NAMES, PRODUCT_VARIANT_ABBREVIATIONS, SUPPORTED_REGIONS } from '../../../shared/enums';
import { selectLocalizationData } from '../../features/localization/localizationSlice';
import {
  selectRegionalPricesData,
  selectRegionalPricesError,
} from '../../features/regionalPrices/regionalPricesSlice';
import { getUnitPrice, getFilterPrice } from '../../features/regionalPrices/regionalPricesHelpers';
import { filterOrderStatic } from '../../static-data';

/**
 * @param page
 * @returns {null|JSX.Element}
 * @constructor
 */
const FilterOrder = ({ page }) => {
  const localization = useSelector(selectLocalizationData);
  const regionalPrices = useSelector(selectRegionalPricesData);
  const error = useSelector(selectRegionalPricesError);

  const sign = CURRENCY_SIGN[localization.region] || CURRENCY_SIGN.US;
  const unitPrice = getUnitPrice(regionalPrices, page);
  const filterPrice = getFilterPrice(regionalPrices, page);

  const {
    title, text, backgroundColor, borderColor, color,
  } = filterOrderStatic[page]
    || filterOrderStatic[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];

  const style = localization.region !== SUPPORTED_REGIONS.SG
    ? {}
    : {
      marginBottom: '40px',
    };

  return error ? null : (
    <div className='filter-order'>
      <div className='container'>
        <div className='filter-order__card' style={{ visibility: 'visible' }}>
          <div className='filter-order__card-primary'>
            <h3 className='filter-order__card-title'>
              <strong>Purchase Mila Air Purifier</strong>
              {' '}
              {page.includes('HW') ? 'starting at just' : 'for just'}
            </h3>
            <p className='filter-order__card-price'>
              <span className='filter-order__price-amount'>
                <span className='currency-symbol'>{sign}</span>
                {unitPrice}
              </span>
              Per unit
            </p>
            <svg className='icon icon-plus' style={{ color }}>
              <use xlinkHref='#icon-plus' />
            </svg>
          </div>
          <div className='filter-order__card-secondary'>
            <h3 className='filter-order__card-title'>
              <strong>
                {`Add ${FILTER_NAMES[page]} filter`}
              </strong>
            </h3>
            <p className='filter-order__card-price' style={style}>
              <span className='filter-order__price-amount filter-order__price-amount--alt'>
                <span className='currency-symbol'>{sign}</span>
                {filterPrice}
              </span>
            </p>
            {localization.region !== SUPPORTED_REGIONS.SG && (
              <p className='filter-order__note'>
                Or
                {' '}
                <strong style={{ color }}>FREE</strong>
                {' '}
                when you subscribe to
                Auto-Refill
              </p>
            )}
            <div className='filter-order__button'>
              <a
                href='https://buy.milacares.com/collections/mila-filter'
                className='btn btn--order btn--fullwidth'
                style={{ backgroundColor, borderColor }}
              >
                Shop Now
              </a>
            </div>
          </div>
        </div>
        <div className='filter-order__intro'>
          <div className='filter-order__content'>
            <h3 className='filter-order__intro-title'>{title}</h3>
            <p>{text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterOrder;
